import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import CompanyActionBtn from '../Buttons/CompanyActionBtn.jsx'
import { companyButtonList } from '../utils/buttonList'
import ModulesWithHover from '../../pages/Companies/ModulesWithHover.jsx'

const CompanyCard = ({ data }) => {
  const [status, setStatus] = useState(null)

  useEffect(() => {
    if (data.company.active && !data.company.suspended) setStatus(companyButtonList[0])
    else if (!data.company.active && !data.company.suspended) setStatus(companyButtonList[1])
    else if (!data.company.active && data.company.suspended) setStatus(companyButtonList[2])
  }, [data])

  return (
    <>
      <Box sx={styles.singleCard}>
        <Box sx={styles.infoContainer}>
          <span>Company Name</span>
          {data.company.name || '---'}
        </Box>

        <Box sx={styles.infoContainer}>
          <span>Company's Tenant</span>
          {data.tenant.name || '---'}
        </Box>

        <Box sx={styles.infoContainer}>
          <span>Company's Modules</span>
          <ModulesWithHover
            companyName={data.company.name}
            modules={data.company.modules}
            />
        </Box>

        <Box sx={styles.infoContainer}>
          <span>Status</span>
          <Box sx={{ color: status?.color }}>{status?.title}</Box>
        </Box>

        <CompanyActionBtn data={data} status={status} statusButtonList={companyButtonList} />
      </Box>
    </>
  )
}

const styles = {
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: { xs: '14px', sm: '16px' },
    padding: '20px',
    paddingRight: { xs: '0px', sm: '50px' },
    margin: '10px 0',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    flexDirection: { xs: 'column', sm: 'row' },
    position: { xs: 'relative', sm: 'unset' },
  },

  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'column' },
    justifyContent: { xs: 'flex-start', sm: 'center' },
    paddingRight: { xs: '0px', sm: 'unset' },
    width: '100%',
    textTransform: 'capitalize',
    alignItems: 'center',
    fontSize: { xs: '10px', sm: '12px' },
    span: {
      display: 'block',
      opacity: '0.7',
      fontSize: { xs: '12px', sm: '14px' },
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: { xs: '0px', sm: '10px' },
      marginRight: { xs: '10px', sm: 'unset' },
    },
  },
}

export default CompanyCard
